import { render, staticRenderFns } from "./repairlogshow.vue?vue&type=template&id=380bcd8f&scoped=true&"
import script from "./repairlogshow.vue?vue&type=script&lang=js&"
export * from "./repairlogshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380bcd8f",
  null
  
)

export default component.exports